import {inject, Injectable, PLATFORM_ID, signal, WritableSignal} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {environment} from '../../../environments/environment';
import {PixelEventName, PixelEventPayloadMap} from './types/pixel.types';

@Injectable({providedIn: 'root'})
export class PixelService {
  private static readonly PIXEL_ID = environment.analytics.meta.pixelId;
  private readonly platformId = inject(PLATFORM_ID);
  private readonly isBrowser = isPlatformBrowser(this.platformId);
  private readonly initialized: WritableSignal<boolean> = signal(false);

  public init(): void {
    if (!this.isBrowser || this.initialized()) return;

    (function (f: any, b: Document) {
      const n: any = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      f.fbq = n;
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];

      const el = b.createElement('script');
      el.async = true;
      el.src = 'https://connect.facebook.net/en_US/fbevents.js';

      const firstScript = b.getElementsByTagName('script')[0];
      firstScript.parentNode?.insertBefore(el, firstScript);
    })(window, document);

    (window as any).fbq('init', PixelService.PIXEL_ID);
    (window as any).fbq('track', 'PageView');

    this.initialized.set(true);
  }

  public trackEvent<E extends PixelEventName>(
    name: E,
    data: PixelEventPayloadMap[E]
  ): void {
    if (!this.isBrowser || !this.initialized()) return;

    const fbq = (window as any).fbq;
    if (!fbq) return;

    fbq('trackCustom', name, data);
  }

  public destroy(): void {
    if (!this.isBrowser || !this.initialized()) return;

    document.querySelector('script[src*="fbevents.js"]')?.remove();
    delete (window as any).fbq;
    delete (window as any)._fbq;

    this.initialized.set(false);
  }
}
